import axios from "axios";
import $store from "@/store/index.js";

/* #####################################################################################################################
Axios instance used to create requests. Imported in components.
This can set up things like URL or headers to all requests when using this instance imported.

Axios instance is returned from a method, each time you call it it's a new one. */

export function $axios() {
  return axios.create({
    // baseURL: "https://telnet.com.pl/index.php/api",
    baseURL: 'http://localhost:8000/api',
    timeout: 15000,
    headers: {
      Authorization: `Bearer ${$store.state.authentication.tokenData.token}`
    }
  });
}

/* ################################################################################################################## */
